import { useEffect } from "react"
import { motion } from "motion/react"
import TrailerPlayer from "./TrailerPlayer"

const DISPLAY = "'Tilda Sans', sans-serif"

export default function TrailerModal({ title, src, onClose }: { title: string; src: string; onClose: () => void }) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") onClose()
        }
        window.addEventListener("keydown", onKey)
        return () => window.removeEventListener("keydown", onKey)
    }, [onClose])

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[200] flex items-center justify-center px-4 py-8"
            style={{ background: "rgba(10,18,42,0.85)", backdropFilter: "blur(8px)" }}
            onClick={onClose}>
            <motion.div
                initial={{ scale: 0.94, y: 12 }}
                animate={{ scale: 1, y: 0 }}
                exit={{ scale: 0.96, y: 8, opacity: 0 }}
                transition={{ type: "spring", stiffness: 320, damping: 28 }}
                className="relative w-full max-w-4xl overflow-hidden rounded-[24px] border border-white/12"
                style={{ background: "linear-gradient(160deg, #1a2d55 0%, #18133b 100%)" }}
                onClick={e => e.stopPropagation()}>
                <div className="flex items-center justify-between gap-3 border-b border-white/10 px-5 py-4">
                    <h4
                        className="min-w-0 truncate text-white"
                        style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 16 }}>
                        {title}
                    </h4>
                    <button
                        type="button"
                        onClick={onClose}
                        aria-label="Закрыть трейлер"
                        className="flex size-9 shrink-0 cursor-pointer items-center justify-center rounded-full border border-white/15 bg-white/[0.06] text-white/70 transition-colors hover:bg-white/[0.12] hover:text-white">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden>
                            <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        </svg>
                    </button>
                </div>
                <div className="relative aspect-video w-full bg-black">
                    <TrailerPlayer
                        src={src}
                        title={title}
                        className="absolute inset-0 h-full w-full border-0"
                    />
                </div>
            </motion.div>
        </motion.div>
    )
}
